import React, { Fragment, useEffect, useState } from "react";
import {
  FinanceChart,
  OrderChart,
  RevenuChart,
  TurnoverChart,
} from "../../../Data/Widgets/Chart/Chart";
import Chart from "react-apexcharts";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { orderStatus, Turnover } from "../../../Constant";
import { Navigation, ShoppingBag } from "react-feather";
import { H3 } from "../../../AbstractElements";
import HeaderCard from "../../Common/Component/HeaderCard";
import { getDataWithToken } from "../../../Utils/restUtils";
import {
  getRevenueChartApi,
  getSubscriptionChartApi,
} from "../../../CommonURL";
import Payment from "./Payment";
const CountrySales = ({ industryId, year, roleId }) => {
  const [display, setDisplay] = useState(false);
  const [revenueCategories, setRevenueCategories] = useState([]);
  const [revenueSeries, setRevenueSeries] = useState([
    {
      name: "Average growth",
      data: [],
    },
  ]);
  const [subscriptionCategories, setSubscriptionCategories] = useState([]);
  const [subscriptionSeries, setSubscriptionSeries] = useState([
    {
      name: "Average growth",
      data: [],
    },
  ]);

  useEffect(() => {
    setTimeout(() => setDisplay(true), 500);
    getRevenueChart();
    getSubscriptionChart();
  }, [industryId, year]);

  const getRevenueChart = async () => {
    let url = getRevenueChartApi;

    if (industryId) url += `?industry_type_id=${industryId}`;
    if (year) url += `${industryId ? "&" : "?"}year=${year}`;

    const data = await getDataWithToken(url);

    if (data?.status) {
      setRevenueCategories(data.data.map((item) => item.month));
      setRevenueSeries([
        {
          name: "Revenue",
          data: data.data.map((item) =>
            Number(String(item.amount).replace(/,/g, "")),
          ),
        },
      ]);
    }
  };

  const getSubscriptionChart = async () => {
    let url = getSubscriptionChartApi;

    if (industryId) url += `?industry_type_id=${industryId}`;
    if (year) url += `${industryId ? "&" : "?"}year=${year}`;

    const data = await getDataWithToken(url);

    if (data?.status) {
      setSubscriptionCategories(data.data.map((item) => item.month));
      setSubscriptionSeries([
        {
          name: "Subscription",
          data: data.data.map((item) => item.amount),
        },
      ]);
    }
  };

  if (!display) {
    return null;
  }
  return (
    <Fragment>
      <Row>
        {roleId === 1 && (
          <Col lg="6" className="box-col-6">
            <Card>
              <CardHeader className="pb-0">
                <Row>
                  <Col className="col-9">
                    <H3>Revenue</H3>
                  </Col>
                  {/* <Col className="col-3 text-end">
                        <Navigation className="text-muted" />
                    </Col> */}
                </Row>
              </CardHeader>
              <CardBody>
                <div className="chart-container">
                  <div id="columnchart">
                    <Chart
                      options={{
                        ...RevenuChart.options,
                        xaxis: {
                          categories: revenueCategories,
                        },
                      }}
                      series={revenueSeries}
                      height={300}
                      type="bar"
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        )}

        <Col lg="6" className="box-col-6">
          <Card>
            <HeaderCard title="Monthly Subscription" setting={true} />
            <CardBody>
              <div className="chart-container">
                <Row>
                  <Col>
                    <div id="chart-widget7">
                      <Chart
                        options={{
                          ...TurnoverChart.options,
                          xaxis: {
                            categories: subscriptionCategories,
                          },
                        }}
                        series={subscriptionSeries}
                        type="area"
                        height={300}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col lg={roleId===1?"12":"6"} className="box-col-6">
                   <Payment industryId={industryId} year={year} />
         
        </Col>
      </Row>
    </Fragment>
  );
};
export default CountrySales;
